import React from 'react'
import '../BusinessFlight/BusinessFlight.css'
import FlightDeal from '../FlightDeals/FlightDeals'
import { FaUserTie, FaHandshake } from "react-icons/fa";
import { MdAirlineSeatReclineExtra } from "react-icons/md";
import { MdOutlinePrivateConnectivity } from "react-icons/md";
import { GiTakeMyMoney } from "react-icons/gi";
import { MdLocalDining } from "react-icons/md";
import BusinessDeal from '../BusinessDeals/BusinessDeal';
const BusinessFlight = () => {
  const deals = [
    { city: "Abu Dhabi", price: "£1052" },
    { city: "Antigua", price: "£1519" },
    { city: "Atlanta", price: "£1528" },
    { city: "Auckland", price: "£2308" },
    { city: "Australia", price: "£2235" },
    { city: "Bahamas", price: "£2373" },
    { city: "Bahrain", price: "£1093" },
    { city: "Bali", price: "£1502" },
    { city: "Bangkok", price: "£1221" },
    { city: "Barbados", price: "£1314" },
    { city: "Beijing", price: "£1444" },
    { city: "Boston", price: "£1346" },
    { city: "Brisbane", price: "£2424" },
    { city: "Buenos Aires", price: "£1449" },
    { city: "Cairns", price: "£2453" },
    { city: "Calgary", price: "£1550" },
    { city: "Cancun", price: "£1590" },
    { city: "Cape Town", price: "£1351" },
    { city: "Charlotte", price: "£1605" },
    { city: "Chicago", price: "£1359" },
    { city: "Dallas", price: "£1400" },
    { city: "Delhi", price: "£1039" },
    { city: "Dubai", price: "£1119" },
    { city: "Dublin", price: "£920" },
    { city: "Frankfurt", price: "£964" },
    { city: "Hong Kong", price: "£1424" },
    { city: "Johannesburg", price: "£1508" },
    { city: "Las Vegas", price: "£1560" },
    { city: "Los Angeles", price: "£1640" },
    { city: "Madrid", price: "£948" },
    { city: "Melbourne", price: "£2480" },
    { city: "Miami", price: "£1484" },
    { city: "Milan", price: "£1000" },
    { city: "Montreal", price: "£1240" },
    { city: "Mumbai", price: "£1072" },
    { city: "New York", price: "£1404" },
    { city: "Orlando", price: "£1320" },
    { city: "Paris", price: "£1024" },
    { city: "Rome", price: "£1056" },
    { city: "San Francisco", price: "£1679" },
    { city: "Seattle", price: "£1460" },
    { city: "Shanghai", price: "£1376" },
    { city: "Singapore", price: "£1512" },
    { city: "Sydney", price: "£2399" },
    { city: "Tokyo", price: "£1564" },
    { city: "Toronto", price: "£1324" },
    { city: "Vancouver", price: "£1440" },
    { city: "Washington", price: "£1364" }
  ];
  
      
      const cardData = [
        { icon: <FaUserTie />, text: "Premium Business Services" },
        { icon: <MdAirlineSeatReclineExtra />, text: "Reclining Seats" },
        { icon: <GiTakeMyMoney />, text: "Cost-Effective Luxury" },
        { icon: <MdLocalDining />, text: "Gourmet Dining" },
        { icon: <MdOutlinePrivateConnectivity />, text: "Private & Peaceful Travel" },
        { icon: <FaHandshake />, text: "Client Satisfaction" },
      ];

      const calladmin = () => {
        window.location.href = "tel:02039449931";
      };
  return (
    <>
<BusinessDeal/>
<div className="text-center p-8">
  <h2 className="text-2xl font-bold mb-4 he4">Journey Experts Business Class – Where Comfort Meets Convenience</h2>
  <p className="het">Start your next holiday or business trip the right way by upgrading to business class. Say goodbye to cramped economy seats and hello to a spacious, more relaxing journey. Business class offers more than just extra legroom—it’s about comfort, convenience, and premium service from check-in to touchdown. At Journey Experts Business, we provide affordable business class flight options, making luxury travel more accessible than you might think.</p>
</div>




    <div className="image-sectionnn">
      <h2 className="section-headingn">Discover Your Next Dream Destination</h2>
      <img
        src="/busi.webp"
        alt="Destination"
        className="section-imagenn"
      />
    </div>









    <div className="business-flight-container">
    <div className="left-section">
    <h2>Affordable Business Class Flights</h2>
    <p>
      At Journey Experts Business, we specialize in securing last-minute and discounted business class flights. 
      Often more cost-effective than booking directly with airlines, we also arrange airport transfers, 
      hotel stays, car rentals, and excursions—covering all your travel needs.
    </p>
    {/*-
    <p>
      Travel with confidence—our excellence has been recognized with the Silver Award in the British Travel Awards 2017 for Best Independent Travel Agency and the Feefo Trusted Merchant Award 2017. Plus, we’re ATOL protected.
    </p>
-*/}
    <h3>Why Choose Business Class?</h3>
    <img src="busennclass4.jpg" alt="Business Class Seat" className="background-image-b" />
    <div className="overlay-content-b">
    <div className="grid-container-b">
          {cardData.map((item, index) => (
            <div className="overlay-card-b" key={index}>
              <div className="icon-b">{item.icon}</div>
              <p className='text-c'>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    <h4>Ultimate Comfort & Reclining Seats</h4>
    <p>
      Business class seats offer premium luxury, often rivaling first class. Whether you’re unwinding after an important meeting or a relaxing getaway, enjoy extra space and a fully reclining seat at the push of a button.
    </p>

    <h3>Gourmet Dining at 30,000 Feet</h3>
    <p>
      Unlike economy class, business class offers complimentary champagne, fine dining, and chef-curated meals, ensuring a first-class culinary experience.
    </p>

    <h3>Private & Peaceful Travel</h3>
    <p>
      Whether you need a quiet space to work mid-flight or simply want to unwind, business class provides a secluded and comfortable environment, perfect for both productivity and relaxation.
    </p>

    <h3>Exclusive Pre-Flight Lounges</h3>
    <p>
      With our discounted business class fares, you gain access to luxurious airport lounges. Enjoy a selection of premium wines, spirits, and chilled champagne, with some airports even offering spa services before takeoff.
    </p>

    <h3>Priority Boarding & Chauffeur Service</h3>
    <p>
      Say goodbye to long boarding queues—business class passengers enjoy priority boarding before premium and economy travelers, ensuring a smooth and stress-free experience.
    </p>

    <h3>First-Class Experience</h3>
    <img src="/bus.jpg" alt="Business Class Seat" />
    <p>
      From dedicated lounges to priority check-in, business class transforms your journey from the moment you step into the terminal. Avoid crowded waiting areas and enjoy premium perks such as fast-track security and private seating.
    </p>

    <p>
      Elevate your travel experience even before reaching the airport with a chauffeur service, making your journey seamless from start to finish. Journey Experts Business ensures you get the best business class fares along with all the added extras that enhance your trip.
    </p>

    <h3>Cost-Effective Luxury</h3>
    <p>
      As specialists in business class travel, we offer exclusive fares that are often more affordable than booking directly with airlines. Our expert team secures the best deals, whether you're traveling for business or leisure. With ATOL protection and top-rated customer service, we ensure a smooth booking experience.
    </p>

    <h3>Unmatched Comfort in the Sky</h3>
    <p>
      Business class flights offer spacious seating, enhanced dining, and exceptional service. Enjoy a peaceful cabin, personalized attention, and world-class amenities—from lie-flat beds to private suites—all at an affordable price.
    </p>

    <p>
      To secure the best business class deals, call Journey Experts Business today or fill out the contact form above, and our team will get in touch with you.
    </p>
</div>

      <div className="right-section">
        <h3>Exclusive Business Deals</h3>
        <ul>
          {deals.map((deal, index) => (
            <li key={index}>
              <span className="city">{deal.city}</span>
              <span className="price">from {deal.price}</span>
              <span onClick={calladmin} className="details">Call Now</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
    </>
  )
}

export default BusinessFlight